var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRightButtonArrowSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 19 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.707 8.707a1 1 0 0 0 0-1.414L12.343.929a1 1 0 1 0-1.414 1.414L16.586 8l-5.657 5.657a1 1 0 0 0 1.414 1.414zM0 9h18V7H0z"
})));
export default SvgIconRightButtonArrowSmall;